export const clampInteger = (
  value: string | number,
  min: number,
  max: number,
  fallback: number = min
): number => {
  const parsed = typeof value === 'string' ? parseInt(value, 10) : value;
  if (Number.isNaN(parsed)) return fallback;
  return Math.min(max, Math.max(min, parsed));
};
